import { defaults } from 'sanitize-html';

import { SanitizationOption } from 'app/utils/htmlSanitizer/types';
export const SANITIZE_PROFILE_DEFAULT: SanitizationOption = {
  allowedAttributes: {
    ...defaults.allowedAttributes,
    a: [...defaults.allowedAttributes.a, 'rel'],
    '*': ['dir'],
  },
  allowedSchemes: [
    'dixa',
    'http',
    'https',
    'mailto',
    'tel',
    'callto',
    // Custom schemes
    'dynamicsnav', // Microsoft Dynamics NAV
    'ms-dynamicsnav', // Microsoft Dynamics NAV
    'kartenmacherei', // Used by Celebrate
  ],
};
